export enum TradingUnit {
  Box = "DS",
  Set = "SET",
}
